import {
  AssessmentOutlined as AssessmentOutlinedIcon,
  Inventory2Outlined as Inventory2OutlinedIcon,
  MenuBookOutlined as MenuBookOutlinedIcon,
  SyncAltOutlined as SyncAltOutlinedIcon,
  TimelineOutlined as TimelineOutlinedIcon,
  UploadFileOutlined as UploadFileOutlinedIcon,
  WarehouseOutlined as WarehouseOutlinedIcon
} from '@mui/icons-material'

export const inventorySections = [
  {
    key: 'warehouses',
    title: 'Bodegas',
    tabLabel: 'Bodegas',
    description: 'Crea y administra bodegas para operar inventario por ubicación.',
    icon: WarehouseOutlinedIcon
  },
  {
    key: 'items',
    title: 'Catálogo productos o servicio',
    tabLabel: 'Catálogo',
    description: 'Administra el catálogo de productos, insumos, servicios y atributos base.',
    icon: Inventory2OutlinedIcon
  },
  {
    key: 'operations',
    title: 'Mantención de inventario',
    tabLabel: 'Mantención',
    description: 'Registra movimientos manuales y transferencias desde una sola pantalla operativa.',
    icon: SyncAltOutlinedIcon
  },
  {
    key: 'recipes',
    title: 'Recetas',
    tabLabel: 'Recetas',
    description: 'Configura recetas base para productos armados o BOM.',
    icon: MenuBookOutlinedIcon
  },
  {
    key: 'stock',
    title: 'Inventario actualizado',
    tabLabel: 'Inventario',
    description: 'Consulta existencias actualizadas por item y bodega.',
    icon: AssessmentOutlinedIcon
  },
  {
    key: 'movements',
    title: 'Ajustes de inventario',
    tabLabel: 'Ajustes',
    description: 'Revisa el historial completo de ajustes, ingresos, salidas y transferencias.',
    icon: TimelineOutlinedIcon
  },
  {
    key: 'uploads',
    title: 'Carga Excel',
    tabLabel: 'Carga Excel',
    description: 'Carga items y stock inicial mediante planillas Excel.',
    icon: UploadFileOutlinedIcon
  },
  {
    key: 'sales-note',
    title: 'Nota de venta',
    tabLabel: 'Nota de venta',
    description: 'Crea notas de venta internas con el mismo lenguaje visual de facturación.',
    icon: MenuBookOutlinedIcon,
    showInTabs: false
  }
]

export const inventorySectionsByKey = inventorySections.reduce((accumulator, section) => {
  accumulator[section.key] = section
  return accumulator
}, {})

export const sectionTabs = inventorySections
  .filter(section => section.key !== 'uploads' && section.showInTabs !== false)
  .map(section => ({
    key: section.key,
    label: section.tabLabel
  }))
